import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ApisService } from 'app/services/apis.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
            encapsulation: ViewEncapsulation.None
  
})
export class NotificationComponent implements OnInit {
  constructor(
    private router: Router,
       private translate: TranslateService,
                  private apisService: ApisService
  ) {}
  public arrCountries: any[] = [];
  public countryId: any[] = [];
  
  public arrOrders: any[] = [];
  public basicSelectedOption: number = 10;

  public selectedStatus = [];
  public searchValue = "";
  public ColumnMode = ColumnMode;

  // private
  public tempData = [];
  public tempFilterData;
  public previousStatusFilter = "";

  @ViewChild(DatatableComponent) table: DatatableComponent;

  ngOnInit(): void {
    this.applyLanguage();
    this.getNotifications();

  }
  applyLanguage(): void {
    const lang = localStorage.getItem('lang') || 'en'; // Default to 'en' if not set
    this.translate.use(lang);
    document.documentElement.lang = lang; // Update <html> tag language attribute

    if (lang === 'ar') {
      document.documentElement.dir = 'rtl'; // Apply RTL direction for Arabic
    } else {
      document.documentElement.dir = 'ltr'; // Apply LTR direction for English
    }
  }
  // getOrders() {
  //   this.apisService.orders().subscribe({
  //     next: (response) => {
  //       console.log(response);
  //       this.arrOrders = response.data;
  //       this.tempData = response.data;
  //       this.loadingService.hide();
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // }

  

 
  filterUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    this.tempData = this.arrOrders.filter((order) =>
      order.name.toLowerCase().includes(val)
    );
  }

  filterByStatus(event) {
    const filter = event ? event.value : "";
    this.previousStatusFilter = filter;
    this.tempFilterData = this.filterRows(filter);
    this.tempData = this.tempFilterData;
  }

  filterRows(statusFilter): any[] {
    if (statusFilter === "") {
      return this.arrOrders;
    } else if (statusFilter === "Other") {
      const mainStatuses = [
        "not set",
        "return",
        "delivered",
        "failed delivery",
      ];
      return this.arrOrders.filter(
        (order) => !mainStatuses.includes(order.delivery_status.toLowerCase())
      );
    }
    return this.arrOrders.filter(
      (order) =>
        order.delivery_status.toLowerCase() === statusFilter.toLowerCase()
    );
  }

  onImageError(event: any) {
    event.target.src = "assets/images/navBar.png";
  }

  getRowClass = (delivery_status) => {
    return {
      "bg-success": delivery_status == "Delivered",
      "bg-danger": delivery_status == "Failed Delivery",
      "bg-warning": delivery_status == "Return",
      "bg-primary": delivery_status == "Not Set",
      "bg-secondary": ![
        "Delivered",
        "Failed Delivery",
        "Return",
        "Not Set",
      ].includes(delivery_status),
    };
  };


  getNotifications() {
    // this.loadingService.show();
    this.apisService.getNotifications().subscribe({
      next: (data) => {
        let response: any = data;
        this.tempData = response.data;
        this.arrCountries = this.tempData;
        console.log(this.arrCountries);
        // this.loadingService.hide();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
}
